"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Item;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function Item({
  children,
  icon
}) {
  if (icon) {
    if (children) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "icon-text"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: icon
      })), /*#__PURE__*/_react.default.createElement("span", null, children));
    } else {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "icon"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: icon
      }));
    }
  } else {
    return /*#__PURE__*/_react.default.createElement("span", null, children);
  }
}

Item.propTypes = {
  children: _propTypes.default.any,
  icon: _propTypes.default.string
};